import Button, { BorderButton } from './Button'

export {
  Button,
  BorderButton
}

export default Button
